import { render, staticRenderFns } from "./ComplaintInfoEdit.vue?vue&type=template&id=0e14d67c&"
import script from "./ComplaintInfoEdit.vue?vue&type=script&lang=js&"
export * from "./ComplaintInfoEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports